import { TipoSituacaoEntidade } from './tipo-situacao-entidade.model';
import { Moment } from 'moment';
import { PessoaFisicaView } from './pessoa-fisica-view.model';

export class SituacaoEntidade {

  id: number;
  idEntidade: number;
  tipoSituacaoEntidade: TipoSituacaoEntidade;
  dataSituacaoEntidade: Moment;
  idMomentoPessoa: number;
  idUnicoPessoa:number;
  pessoaFisicaView: PessoaFisicaView
}
